import React, { createContext, useContext, useEffect, useState } from "react";
import { storage } from "./storage";
import { sacredTranslations } from "./sacredTranslations";

export const strings = {
  ...sacredTranslations,
  fateh: { en: "Waheguru Ji Ka Khalsa", hi: "वाहेगुरु जी का खालसा", pa: "ਵਾਹਿਗੁਰੂ ਜੀ ਕਾ ਖ਼ਾਲਸਾ" },
  fatehReply: { en: "Waheguru Ji Ki Fateh", hi: "वाहेगुरु जी की फ़तह", pa: "ਵਾਹਿਗੁਰੂ ਜੀ ਕੀ ਫ਼ਤਹਿ" },
  chooseLanguage: { en: "Choose your language", hi: "अपनी भाषा चुनें", pa: "ਆਪਣੀ ਭਾਸ਼ਾ ਚੁਣੋ" },
  continue: { en: "Continue", hi: "जारी रखें", pa: "ਅੱਗੇ ਵਧੋ" },
  back: { en: "Back", hi: "वापस", pa: "ਵਾਪਸ" },
  regTitle: { en: "Create your GurSetu Profile", hi: "अपना गुरसेतु प्रोफ़ाइल बनाएं", pa: "ਆਪਣਾ ਗੁਰਸੇਤੂ ਪ੍ਰੋਫਾਈਲ ਬਣਾਓ" },
  fullName: { en: "Full Name", hi: "पूरा नाम", pa: "ਪੂਰਾ ਨਾਮ" },
  email: { en: "Email", hi: "ईमेल", pa: "ਈਮੇਲ" },
  city: { en: "City", hi: "शहर", pa: "ਸ਼ਹਿਰ" },
  country: { en: "Country", hi: "देश", pa: "ਦੇਸ਼" },
  finish: { en: "Continue toward GurSetu", hi: "ऐप में प्रवेश करें", pa: "ਐਪ ਵਿੱਚ ਦਾਖਲ ਹੋਵੋ" },
  home: { en: "Home", hi: "होम", pa: "ਹੋਮ" },
  hukamnama: { en: "Hukamnama", hi: "हुक्मनामा", pa: "ਹੁਕਮਨਾਮਾ" },
  simran: { en: "Simran", hi: "सिमरन", pa: "ਸਿਮਰਨ" },
  ai: { en: "AI Sahayak", hi: "AI सहायक", pa: "AI ਸਹਾਇਕ" },
  settings: { en: "Settings", hi: "सेटिंग्स", pa: "ਸੈਟਿੰਗਸ" },
  todaysHukamnama: { en: "Today's Hukamnama", hi: "आज का हुक्मनामा", pa: "ਅੱਜ ਦਾ ਹੁਕਮਨਾਮਾ" },
  todaysQuote: { en: "Today's Divine Quote", hi: "आज का दिव्य वचन", pa: "ਅੱਜ ਦਾ ਦਿਵਯ ਵਚਨ" },
  save: { en: "Save", hi: "सहेजें", pa: "ਸੰਭਾਲੋ" },
  share: { en: "Share", hi: "साझा करें", pa: "ਸਾਂਝਾ ਕਰੋ" },
  viewMore: { en: "View More", hi: "और देखें", pa: "ਹੋਰ ਵੇਖੋ" },
  reflection: { en: "Today's Reflection (Do This Task)", hi: "आज का चिंतन (यह काम करें)", pa: "ਅੱਜ ਦਾ ਵਿਚਾਰ (ਇਹ ਕੰਮ ਕਰੋ)" },
  ang: { en: "Ang", hi: "अंग", pa: "ਅੰਗ" },
  raag: { en: "Raag", hi: "राग", pa: "ਰਾਗ" },
  language: { en: "Language", hi: "भाषा", pa: "ਭਾਸ਼ਾ" },
  fontSize: { en: "Font size", hi: "फ़ॉन्ट आकार", pa: "ਫ਼ੌਂਟ ਸਾਈਜ਼" },
  theme: { en: "Theme", hi: "थीम", pa: "ਥੀਮ" },
  preferredGurudwara: { en: "Preferred Gurudwara", hi: "पसंदीदा गुरुद्वारा", pa: "ਪਸੰਦੀਦਾ ਗੁਰਦੁਆਰਾ" },
  about: { en: "About", hi: "बारे में", pa: "ਬਾਰੇ" },
  loading: { en: "Loading…", hi: "लोड हो रहा है…", pa: "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ…" },
  calendar: { en: "Calendar", hi: "कैलेंडर", pa: "ਕੈਲੰਡਰ" },
  nitnem: { en: "Nitnem", hi: "नितनेम", pa: "ਨਿਤਨੇਮ" },
  liveKirtan: { en: "Live Kirtan", hi: "लाइव कीर्तन", pa: "ਲਾਈਵ ਕੀਰਤਨ" },
  waheguru: { en: "Waheguru", hi: "वाहेगुरु", pa: "ਵਾਹਿਗੁਰੂ" },
  moolMantar: { en: "Mool Mantar", hi: "मूल मंत्र", pa: "ਮੂਲ ਮੰਤਰ" },
  start: { en: "Start", hi: "शुरू", pa: "ਸ਼ੁਰੂ" },
  stop: { en: "Stop", hi: "रोकें", pa: "ਰੋਕੋ" },
  send: { en: "Send", hi: "भेजें", pa: "ਭੇਜੋ" },
  bookmarks: { en: "Bookmarks", hi: "बुकमार्क", pa: "ਬੁੱਕਮਾਰਕ" },
  events: { en: "Events", hi: "कार्यक्रम", pa: "ਈਵੈਂਟਸ" },
  gallery: { en: "Gallery", hi: "गैलरी", pa: "ਗੈਲਰੀ" },
  digital_yatra: { en: "Digital Yatra", hi: "डिजिटल यात्रा", pa: "ਡਿਜੀਟਲ ਯਾਤਰਾ" },
  sikh_quest: { en: "Sikh Quest", hi: "सिख क्वेस्ट", pa: "ਸਿੱਖ ਕੁਐਸਟ" },
  guru_inspiration: { en: "Guru Inspiration", hi: "गुरु प्रेरणा", pa: "ਗੁਰੂ ਪ੍ਰੇਰਨਾ" },
  hukam_journal: { en: "Hukam Journal", hi: "हुकम पत्रिका", pa: "ਹੁਕਮ ਜਰਨਲ" },
  // ============================================================
// i18n.jsx me ADD karne wala PORTION — sirf ye keys apne
// existing `strings = { ... }` object ke ANDAR paste karo
// (kahin bhi, jaise "Common" section ke baad). Baaki poori
// file jaisi hai waisi hi rehne do, sirf ye naye keys add karo.
// ============================================================

  // Nitnem Reader screen
  loadingBani: { en: "Loading Sacred Bani...", hi: "पवित्र बानी लोड हो रही है...", pa: "ਪਵਿੱਤਰ ਬਾਣੀ ਲੋਡ ਹੋ ਰਹੀ ਹੈ..." },
  loadingBaniSub: { en: "Please wait while we fetch the divine words", hi: "कृपया प्रतीक्षा करें, दिव्य वचन लाए जा रहे हैं", pa: "ਕਿਰਪਾ ਕਰਕੇ ਉਡੀਕ ਕਰੋ, ਦਿਵਯ ਸ਼ਬਦ ਲਿਆਏ ਜਾ ਰਹੇ ਹਨ" },
  retry: { en: "Retry", hi: "फिर कोशिश करें", pa: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ" },
  tryAgain: { en: "Try Again", hi: "फिर से कोशिश करें", pa: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ" },
  checkConnection: { en: "If loading takes too long, please check your internet connection", hi: "अगर लोड होने में ज़्यादा समय लग रहा है, तो अपना इंटरनेट कनेक्शन जांचें", pa: "ਜੇ ਲੋਡ ਹੋਣ ਵਿੱਚ ਬਹੁਤ ਸਮਾਂ ਲੱਗ ਰਿਹਾ ਹੈ, ਤਾਂ ਆਪਣਾ ਇੰਟਰਨੈੱਟ ਕਨੈਕਸ਼ਨ ਜਾਂਚੋ" },
  unableToLoadBani: { en: "Unable to Load Bani", hi: "बानी लोड नहीं हो सकी", pa: "ਬਾਣੀ ਲੋਡ ਨਹੀਂ ਹੋ ਸਕੀ" },
  multipleAttemptsFailed: { en: "Multiple attempts failed. Please check your connection or try again later.", hi: "कई प्रयास असफल रहे। कृपया अपना कनेक्शन जांचें या बाद में फिर कोशिश करें।", pa: "ਕਈ ਕੋਸ਼ਿਸ਼ਾਂ ਅਸਫਲ ਰਹੀਆਂ। ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਕਨੈਕਸ਼ਨ ਜਾਂਚੋ ਜਾਂ ਬਾਅਦ ਵਿੱਚ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ।" },
  couldntLoadBaniReasons: { en: "We couldn't load this Bani. This might be due to:", hi: "यह बानी लोड नहीं हो सकी। इसका कारण हो सकता है:", pa: "ਇਹ ਬਾਣੀ ਲੋਡ ਨਹੀਂ ਹੋ ਸਕੀ। ਇਸਦਾ ਕਾਰਨ ਹੋ ਸਕਦਾ ਹੈ:" },
  reasonInternet: { en: "Internet connection issue", hi: "इंटरनेट कनेक्शन की समस्या", pa: "ਇੰਟਰਨੈੱਟ ਕਨੈਕਸ਼ਨ ਦੀ ਸਮੱਸਿਆ" },
  reasonServer: { en: "Server temporarily unavailable", hi: "सर्वर अस्थायी रूप से अनुपलब्ध है", pa: "ਸਰਵਰ ਅਸਥਾਈ ਤੌਰ 'ਤੇ ਉਪਲਬਧ ਨਹੀਂ" },
  reasonInvalidId: { en: "Invalid Bani ID", hi: "अमान्य बानी आईडी", pa: "ਗਲਤ ਬਾਣੀ ਆਈਡੀ" },
  backToNitnem: { en: "Back to Nitnem", hi: "नितनेम पर वापस जाएं", pa: "ਨਿਤਨੇਮ ਤੇ ਵਾਪਸ ਜਾਓ" },
  attemptOf: { en: "Attempt {n} of {max}", hi: "प्रयास {n} में से {max}", pa: "ਕੋਸ਼ਿਸ਼ {n} ਵਿੱਚੋਂ {max}" },
  clickToFocus: { en: "Click to focus", hi: "फ़ोकस के लिए टैप करें", pa: "ਫੋਕਸ ਲਈ ਟੈਪ ਕਰੋ" },
  discoverMeaning: { en: "Discover the meaning behind this verse", hi: "इस पंक्ति का अर्थ जानें", pa: "ਇਸ ਪੰਗਤੀ ਦਾ ਅਰਥ ਜਾਣੋ" },
  askSahayak: { en: "Ask Sahayak", hi: "सहायक से पूछें", pa: "ਸਹਾਇਕ ਨੂੰ ਪੁੱਛੋ" },
  displaySettings: { en: "Display Settings", hi: "डिस्प्ले सेटिंग्स", pa: "ਡਿਸਪਲੇ ਸੈਟਿੰਗਸ" },
  fontSizeSmall: { en: "Small", hi: "छोटा", pa: "ਛੋਟਾ" },
  fontSizeMedium: { en: "Medium", hi: "मध्यम", pa: "ਦਰਮਿਆਨਾ" },
  fontSizeLarge: { en: "Large", hi: "बड़ा", pa: "ਵੱਡਾ" },
  showTranslation: { en: "Show Translation", hi: "अनुवाद दिखाएं", pa: "ਅਨੁਵਾਦ ਵਿਖਾਓ" },
  sahayakReflecting: { en: "Sahayak is reflecting…", hi: "सहायक विचार कर रहा है…", pa: "ਸਹਾਇਕ ਵਿਚਾਰ ਕਰ ਰਿਹਾ ਹੈ…" },
  analyzingDivineMsg: { en: "Analyzing the divine message", hi: "दिव्य संदेश का विश्लेषण हो रहा है", pa: "ਦਿਵਯ ਸੁਨੇਹੇ ਦਾ ਵਿਸ਼ਲੇਸ਼ਣ ਹੋ ਰਿਹਾ ਹੈ" },
  continueWithSahayak: { en: "Continue with Sahayak", hi: "सहायक के साथ जारी रखें", pa: "ਸਹਾਇਕ ਨਾਲ ਜਾਰੀ ਰੱਖੋ" },
  close: { en: "Close", hi: "बंद करें", pa: "ਬੰਦ ਕਰੋ" },
  contentBeingSourced: { en: "Content is being sourced for this Bani.", hi: "इस बानी के लिए सामग्री तैयार की जा रही है।", pa: "ਇਸ ਬਾਣੀ ਲਈ ਸਮੱਗਰੀ ਤਿਆਰ ਕੀਤੀ ਜਾ ਰਹੀ ਹੈ।" },
  audioNotAvailable: { en: "Audio not available for this Bani", hi: "इस बानी के लिए ऑडियो उपलब्ध नहीं है", pa: "ਇਸ ਬਾਣੀ ਲਈ ਆਡੀਓ ਉਪਲਬਧ ਨਹੀਂ" },
  audioLoadError: { en: "Audio failed to load", hi: "ऑडियो लोड नहीं हो सका", pa: "ਆਡੀਓ ਲੋਡ ਨਹੀਂ ਹੋ ਸਕਿਆ" },
  audioUnavailableWorking: { en: "Audio unavailable right now… we are working on it 🙏", hi: "ऑडियो अभी उपलब्ध नहीं है... हम इस पर काम कर रहे हैं 🙏", pa: "ਆਡੀਓ ਹੁਣੇ ਉਪਲਬਧ ਨਹੀਂ... ਅਸੀਂ ਇਸ ਤੇ ਕੰਮ ਕਰ ਰਹੇ ਹਾਂ 🙏" },
  invalidBaniId: { en: "Invalid Bani ID", hi: "अमान्य बानी आईडी", pa: "ਗਲਤ ਬਾਣੀ ਆਈਡੀ" },
  baniLoadedSuccess: { en: "{name} loaded successfully", hi: "{name} सफलतापूर्वक लोड हुआ", pa: "{name} ਸਫਲਤਾਪੂਰਵਕ ਲੋਡ ਹੋਇਆ" },
  baniNotFound: { en: "Bani not found", hi: "बानी नहीं मिली", pa: "ਬਾਣੀ ਨਹੀਂ ਮਿਲੀ" },
  serverError: { en: "Server error. Please try again later.", hi: "सर्वर त्रुटि। कृपया बाद में फिर कोशिश करें।", pa: "ਸਰਵਰ ਗਲਤੀ। ਕਿਰਪਾ ਕਰਕੇ ਬਾਅਦ ਵਿੱਚ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ।" },
  failedToLoadCheckConn: { en: "Failed to load Bani. Please check your connection.", hi: "बानी लोड नहीं हो सकी। कृपया अपना कनेक्शन जांचें।", pa: "ਬਾਣੀ ਲੋਡ ਨਹੀਂ ਹੋ ਸਕੀ। ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਕਨੈਕਸ਼ਨ ਜਾਂਚੋ।" },
  requestTimedOut: { en: "Request timed out. Please check your internet connection.", hi: "अनुरोध का समय समाप्त हो गया। कृपया अपना इंटरनेट कनेक्शन जांचें।", pa: "ਬੇਨਤੀ ਦਾ ਸਮਾਂ ਸਮਾਪਤ ਹੋ ਗਿਆ। ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਇੰਟਰਨੈੱਟ ਕਨੈਕਸ਼ਨ ਜਾਂਚੋ।" },
  removedFromBookmarks: { en: "Removed from bookmarks", hi: "बुकमार्क से हटाया गया", pa: "ਬੁੱਕਮਾਰਕ ਤੋਂ ਹਟਾਇਆ ਗਿਆ" },
  addedToBookmarks: { en: "Added to bookmarks", hi: "बुकमार्क में जोड़ा गया", pa: "ਬੁੱਕਮਾਰਕ ਵਿੱਚ ਸ਼ਾਮਲ ਕੀਤਾ ਗਿਆ" },
  bookmarkUpdateFailed: { en: "Failed to update bookmarks", hi: "बुकमार्क अपडेट नहीं हो सका", pa: "ਬੁੱਕਮਾਰਕ ਅੱਪਡੇਟ ਨਹੀਂ ਹੋ ਸਕਿਆ" },
  couldNotLoadExplanation: { en: "Could not load explanation. Please try again later.", hi: "व्याख्या लोड नहीं हो सकी। कृपया बाद में फिर कोशिश करें।", pa: "ਵਿਆਖਿਆ ਲੋਡ ਨਹੀਂ ਹੋ ਸਕੀ। ਕਿਰਪਾ ਕਰਕੇ ਬਾਅਦ ਵਿੱਚ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ।" },
  kids_mode: { en: "Kids Mode", hi: "बच्चों का मोड", pa: "ਬੱਚੇ ਮੋਡ" },
};

const LANG_LABELS = { en: "English", hi: "हिंदी", pa: "ਪੰਜਾਬੀ" };
const LANGS = ["en", "hi", "pa"];

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const s = storage.get("ck_lang", "en");
    return LANGS.includes(s) ? s : "en";
  });
  const setLang = (l) => { setLangState(l); storage.set("ck_lang", l); };
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const t = (key) => strings[key]?.[lang] ?? strings[key]?.en ?? key;
  return <I18nContext.Provider value={{ lang, setLang, t, LANG_LABELS, LANGS }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
